import { BaseModel, type RelationConfig } from './base';

// Enums

export enum EmailTemplateStatus {
  system = 'system',
  override = 'override',
  disabled = 'disabled',
}

export const EmailTemplateStatusLabels: Record<EmailTemplateStatus, string> = {
  [EmailTemplateStatus.system]: 'general.system',
  [EmailTemplateStatus.override]: 'general.override',
  [EmailTemplateStatus.disabled]: 'general.disabled',
};

// Helper Classes

export class MasterTemplate extends BaseModel {}

export class EmailTemplateType extends BaseModel {}

export class EmailTypes extends BaseModel {
  type!: EmailTemplateType | null;
  status!: EmailTemplateStatus;
  template!: EmailTemplate | null;

  static override relations(): RelationConfig {
    return {
      type: { type: EmailTemplateType },
      template: { type: EmailTemplate },
    };
  }

  get isEmailTemplateStatusSystem(): boolean {
    return this.status === EmailTemplateStatus.system;
  }

  get isEmailTemplateStatusOverride(): boolean {
    return this.status === EmailTemplateStatus.override;
  }

  get isEmailTemplateStatusDisabled(): boolean {
    return this.status === EmailTemplateStatus.disabled;
  }
}

export class Templates extends BaseModel {
  masterTemplates!: MasterTemplate[];
  emailTypes!: EmailTypes[];

  static override relations(): RelationConfig {
    return {
      masterTemplates: { type: MasterTemplate },
      emailTypes: { type: EmailTypes },
    };
  }
}

// Main Model

export class EmailTemplate extends BaseModel {
  idLocationEmailTemplate!: number;
  type!: string;
  subject!: string;
  htmlBody!: string;
  enabled!: boolean;

  override objectID(): string | null {
    return this.idLocationEmailTemplate?.toString() ?? null;
  }
}
